var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9636 2.94922H10.5136C10.0892 2.94922 9.68226 3.11779 9.3822 3.41785C9.08214 3.71791 8.91357 4.12487 8.91357 4.54922V20.4392C8.91357 20.8645 9.08182 21.2725 9.38159 21.5741C9.68137 21.8758 10.0883 22.0466 10.5136 22.0492H15.9636C16.1745 22.0492 16.3834 22.0075 16.5782 21.9265C16.773 21.8454 16.9498 21.7267 17.0985 21.5771C17.2472 21.4274 17.3648 21.2499 17.4447 21.0546C17.5245 20.8593 17.5649 20.6502 17.5636 20.4392V4.54922C17.5636 4.12487 17.395 3.71791 17.0949 3.41785C16.7949 3.11779 16.3879 2.94922 15.9636 2.94922Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2168 9.18945H9.26367V9.88945H17.2168V9.18945Z",
    fill: "#363A45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82373 5.98828V7.80828H10.8237V5.98828H9.82373Z",
    fill: "#00C65E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82373 11.2695V13.0895H10.8237V11.2695H9.82373Z",
    fill: "#00C65E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2169 9.1893H16.0669C16.1118 8.09482 15.9208 7.00348 15.5069 5.9893C15.0226 4.90073 14.2518 3.96408 13.2769 3.2793H16.0969C16.3939 3.2793 16.6788 3.3973 16.8888 3.60734C17.0989 3.81738 17.2169 4.10225 17.2169 4.3993V9.1893Z",
    fill: "#00C65E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.5e319705978a55d4feb308e632169181.svg";
export { ForwardRef as ReactComponent };